module.exports = __webpack_public_path__ + "static/img/855.5ce645d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/rjzz/855.jpg
// module id = 9zza
// module chunks = 0